import { AsyncStateNotification } from '@ui/notifications';
import { COPY_GENERIC } from '@sonar-software/sonar-ts-constants';
import { coreActions } from '@sonar-software/sonar-core';
import { createSonarSelector } from '@lib/selectors';
import React from 'react';

const deleteSelector = createSonarSelector((state) => state.core.stakeholders.delete);

export const DeleteStakeholderNotifications: React.FC = () =>
	<AsyncStateNotification
		errored={ COPY_GENERIC.CONTACT_SUPPORT }
		failed={ COPY_GENERIC.CONTACT_SUPPORT }
		resetRawAction={ coreActions.resetDeleteCoreStakeholders }
		stateSelector={ deleteSelector } />;

